/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import {
    object, string, number, bool, shape,
} from 'prop-types';
import Grid from '@material-ui/core/Grid';
import { connect } from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import { getBrand } from '../../../../../../state/ducks/App/ducks/Brand/Brand-Selectors';

import AccountLeftMenu from '../../../common/Desktop/AccountLeftMenu';
// import DesktopAccountSocialLogin from './DesktopAccountSocialLogin/DesktopAccountSocialLogin';
import DesktopAccountUserProfile from './DesktopAccountUserProfile/DesktopAccountUserProfile';
// import DesktopAccountBillingAddress from './DesktopAccountBillingAddress/DesktopAccountBillingAddress';
// import DesktopAccountPaymentMethod from './DesktopAccountPaymentMethod/DesktopAccountPaymentMethod';
import DesktopAccountEmailpreference from './DesktopAccountEmailPreference/DesktopAccountEmailPreference';
// import DesktopAccountRecentOrders from './DesktopAccountRecentOrders/DesktopAccountRecentOrders';
import CustomerWrapperPLA from '../../../../ViewCustomerServices/style/common/CustomerPanelPLAStyle';

const styles = (theme) => CustomerWrapperPLA(theme);

const DesktopAccountHome = ({
    userProfile, featureFlags, brand, classes,
}) => (
    <Grid container className={`container ${classes.CustomerWrapperPLA} ${brand.code}`}>
        <AccountLeftMenu userProfile={userProfile} featureFlags={featureFlags} brand={brand} />

        <Grid item xs={10}>
            <Grid className="contentGrid" container item xs={12}>
                <Grid className="block position-relative" item xs={4}>
                    <div className="blockHeader">Profile</div>
                    <DesktopAccountUserProfile userProfile={userProfile} />
                </Grid>
                <Grid className="block position-relative" item xs={4}>
                    <div className="blockHeader">Email Preferences </div>
                    <DesktopAccountEmailpreference userProfile={userProfile} />
                </Grid>
            </Grid>
        </Grid>
    </Grid>
);

DesktopAccountHome.propTypes = {
    userProfile: shape({
        accessToken: string,
        idToken: string,
        ContactId: string,
        userType: string,
        userRole: string,
        email: string,
        aud: string,
        iat: number,
        exp: number,
        sub: string,
        firstName: string,
        lastName: string,
        loginsCount: number,
        isAuthenticated: bool,
        isGuestAccount: bool,
    }).isRequired,
    featureFlags: object.isRequired,
    brand: object.isRequired,
    classes: object.isRequired,
};

const mapStateToProps = (state) => ({
    brand: getBrand(state),
});

export default connect(mapStateToProps)(withStyles(styles)(DesktopAccountHome));
